import React from "react";
import Select from "react-select";
import { IMAGE_BASE_URL } from "../helpers/constants";

export default function CustomSelect({
  options,
  value,
  setValue,
  error,
  placeholder,
  disabled,
  viewMode,
  customLabel = false,
  customValue = false,
  required = false,
}) {
  //console.log("options", value);
  return (
    <div className={`relative pb-3 md:pb-5 ${viewMode ? "opacity-50" : ""}`}>
      <select
        className={`${
          error && viewMode ? "border-red-500" : "px-2 pr-0"
        } input`}
        value={value ? value : ""}
        defaultValue={"SG"}
        disabled={disabled || viewMode}
        onChange={(e) => setValue(e.target.value)}
        required={required}
      >
        <option value={""}>{placeholder}</option>
        {options.map((item, index) => {
          return (
            <option
              data-image={`${IMAGE_BASE_URL}/${item["icon"]}`}
              key={index}
              value={customValue ? item[customValue] : item.id}
            >
              <div className="flex flex-row items-center">
                {item["icon"] ? (
                  <img
                    src={`${IMAGE_BASE_URL}/${item["icon"]}`}
                    className="w-6 h-6"
                  />
                ) : null}
                {customLabel ? item[customLabel] : item.name}
              </div>
            </option>
          );
        })}
      </select>
    </div>
  );
}

